/**
 * Copyright © IMPACT Commerce AB. All rights reserved.
 * See COPYING.txt for license details.
 */

import { DialogComponent } from '@theme/dialog';

/**
 * Opens the Voyado Back in Stock form from the add to cart button when the selected variant
 * is sold out.
 *
 * The Voyado app block reads the selected variant from the product form, so the form only has
 * to be revealed — the variant it subscribes to is already the one the shopper picked.
 *
 * @extends {DialogComponent}
 */
class BackInStockPopup extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    this.#section?.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener('click', this.#handleClick);
    super.disconnectedCallback();
  }

  get #section() {
    return this.closest('.shopify-section');
  }

  /**
   * @param {Event} event
   */
  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('[data-notify-me="true"]')) return;

    event.preventDefault();
    this.showDialog();
  };
}

if (!customElements.get('back-in-stock-popup')) {
  customElements.define('back-in-stock-popup', BackInStockPopup);
}
